var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('s-search-staff',{attrs:{"select":_vm.local.signer,"label":_vm.$t('Outbox.Signer'),"show-support-staff":""},on:{"update:select":function($event){return _vm.$set(_vm.local, "signer", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }